export const DevelopmentConfig = {
  PORT: 3006,
  DEBUG: true,
  FRONTDESK_URL: "https://frondesq.com",
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL_DEV,
  PAYSTACK_PUBLIC_KEY: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY_DEV,
  PAYSTACK_SECRET_KEY: process.env.REACT_APP_PAYSTACK_SECRET_KEY_DEV,
  CSC_API_KEY: process.env.REACT_APP_CSC_API_KEY,
}
